module.exports = __webpack_public_path__ + "3f16e137/img/pwrd-by-sourcery-black.bba9ba41.svg";